import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApiGetNoAuth, ApiPostNoAuth } from "../../ApiSetUp/CommonApi";
import { api, BaseUrl } from "../../ApiSetUp/AuthApi";


//--------------------- Po Apis ------------------------------
export const getProcessItems = createAsyncThunk(
    "getProcessItems",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.getProcessItems, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const getLotNumbersByCategory = createAsyncThunk(
    "getLotNumbersByCategory",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.getLotNumbersByCategory, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const getItemsByCategory = createAsyncThunk(
    "getItemsByCategory",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.getItemsByCategory, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const addProcessItem = createAsyncThunk(
    "addProcessItem",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.addProcessItem, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const getProcessItemById = createAsyncThunk(
    "getProcessItemById",
    async (body) => {
        return ApiGetNoAuth(BaseUrl, api.getProcessItemById + body, {})
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const updateProcessItem = createAsyncThunk(
    "updateProcessItem",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.updateProcessItem, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const deleteProcessItem = createAsyncThunk(
    "deleteProcessItem",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.deleteProcessItem + body, {})
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);